'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* global tinymce */

var getGlobal = function getGlobal() {
  return typeof window !== 'undefined' ? window : global;
};

var getTinymce = function getTinymce() {
  var global = getGlobal();

  return global && global.tinymce ? global.tinymce : null;
};

var IDRichText = function (_Component) {
  (0, _inherits3.default)(IDRichText, _Component);

  function IDRichText(props) {
    var _this2 = this;

    (0, _classCallCheck3.default)(this, IDRichText);

    var _this = (0, _possibleConstructorReturn3.default)(this, (IDRichText.__proto__ || (0, _getPrototypeOf2.default)(IDRichText)).call(this, props));

    _this.getComponent = function () {
      return tinymce.get(_this.props.id);
    };

    _this.onChange = function () {
      _this.props.onChange && _this.props.onChange(_this.getComponent() && _this.getComponent().getContent());
    };

    _this.onBlur = function () {
      _this.props.onBlur && _this.props.onBlur(_this.getComponent() && _this.getComponent().getContent());
    };

    _this.initEditor = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
      var me, _this$props, toolbar, plugins, menubar, setting, readOnly, disabled, isDisplay, init;

      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              me = _this;
              _this$props = _this.props, toolbar = _this$props.toolbar, plugins = _this$props.plugins, menubar = _this$props.menubar, setting = _this$props.setting, readOnly = _this$props.readOnly, disabled = _this$props.disabled, isDisplay = _this$props.isDisplay;
              init = (0, _extends3.default)({
                selector: '#' + _this.props.id,
                height: 350,
                statusbar: false,
                menubar: menubar,
                plugins: plugins,
                toolbar: toolbar
              }, setting, {
                readonly: readOnly || disabled || isDisplay ? 1 : 0,
                init_instance_callback: function init_instance_callback(editor) {
                  editor.setContent(me.state.value);
                  editor.on('blur', function (e) {
                    me.onBlur(e);
                  });
                },
                setup: function setup(ed) {
                  me.editor = ed;
                  ed.on('keyup', function () {
                    me.change();
                  });
                  ed.on('change', function (e) {
                    me.change();
                  });
                }
              });


              getTinymce().init(init);

            case 4:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }));
    _this.change = _lodash2.default.debounce(_this.onChange, 500);

    _this.state = {
      value: props.value ? props.value : ''
    };
    _this.dataTestID = 'rick-text';
    _this.inputType = 'richText';
    return _this;
  }

  (0, _createClass3.default)(IDRichText, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.initEditor();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.editor && this.editor.initialized) {
        if (nextProps.value !== this.getValue()) {
          this.getComponent() && this.getComponent().setContent(nextProps.value ? nextProps.value : '');
        }
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      // this.getComponent() && this.getComponent().remove();
      getTinymce().remove(this.editor);
    }
  }, {
    key: 'getValue',
    value: function getValue() {
      if (this.getComponent()) {
        return this.getComponent().getContent();
      }
      return null;
    }
  }, {
    key: 'setValue',
    value: function setValue(value) {
      this.getComponent() && this.getComponent().setContent(value || '');
    }
  }, {
    key: 'getDataTestId',
    value: function getDataTestId() {
      var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'component';

      return this.props.dataTestID || this.dataTestID + '-' + prefix;
    }
  }, {
    key: 'render',
    value: function render() {
      // if (!this.props.fromIDInput) {
      //   throw new Error(`Vui lòng sử dụng <IDInput type="${this.inputType}" />`);
      // }

      return _react2.default.createElement('div', {
        'data-testid': this.getDataTestId(),
        id: this.props.id
      });
    }
  }]);
  return IDRichText;
}(_react.Component);

exports.default = IDRichText;


IDRichText.defaultProps = {
  id: 'rich-editor',
  plugins: 'link fullscreen image lists',
  toolbar: 'undo redo | fontselect | formatselect fontsizeselect bold italic underline | numlist bullist | alignleft aligncenter alignright alignjustify | forecolor backcolor | link image fullscreen | outdent indent ',
  menubar: false,
  setting: {}
};